$(window).on('load',function(){



var tl1 = gsap.timeline({});
tl1.fromTo(".anim",{x:"-100%"},{x:"200%",duration:1.3,stagger:0.3,ease: "power3.out"});
tl1.fromTo(".copy_box p",{opacity:0},{delay:-2,opacity:1,stagger:0.3,duration:0.5,ease: "power3.out"});




news_more();

$(".message_btn a").on("click",function(){
  event.preventDefault();
  $("section#message").addClass("active");
  gsap.fromTo("section#message .inner",{opacity:0,y:20},{opacity:1,y:0,delay:0.3})
})

$(".mclose").on("click",function(){
  event.preventDefault();
  $("section#message").removeClass("active");
})

});



function news_more(){
 
  var more = $(".more a");
  var t = $("#newsmore");
  var c = $(".news_container i");
  var th = t.innerHeight();
  gsap.set(t,{height:0});
  more.on("click",function(){
       $(this).parent().parent().parent().find(".news_old").slideToggle();
       $(".news_old").addClass("active");
  });
  c.on("click",function(){
   
    $(".news_old").removeClass("active");
  })
}



